<div [ngClass]="type">
  <i class="app-icon-alert"></i>
  <h4>{{ title }}</h4>
  <p>{{ message }}</p>
</div>
